@if (block(); as block) {
  <section class="block-cta-cards section-outset-y container">
    @if ((block.title || block.subtitle) && !block.hideTitle) {
      <header class="mb-4">
        @if (block.subtitle) {
          <strong class="fs-body-md fw-semi mb-2 text-primary d-inline-block w-100">{{ block.subtitle }}</strong>
        }
        @if (block.title) {
          <h2 class="h3 mb-0">
            {{ block.title }}
          </h2>
        }
      </header>
    }
    <ul
      class="list-unstyled row"
      [ngClass]="block.compact ? 'gutter-x-2 gutter-y-2' : 'gutter-x-3 gutter-x-lg-4 gutter-x-xl-5 gutter-y-3 gutter-y-lg-4 gutter-y-xl-5'"
    >
      @for (card of block.ctaItems; track card.id; let i = $index) {
        <li [ngClass]="ctaCardsColumns" class="block-cta-cards__list__item">
          <app-cta-card [card]="card" [index]="i" [size]="block.compact ? 'small' : undefined" [hideImage]="!!block.compact"></app-cta-card>
        </li>
      }
    </ul>
  </section>
}
